module.exports = {
  schema: {
    name: '員工資料',
    type: 'Object',
    contents: {
      ragicId: {
        name: 'Ragic Id',
        type: 'Number',
        ragicId: '_ragicId',
        disabled: true,
      },
      code: {
        type: 'String',
        name: '代碼',
        unique: true,
        ragicId: '1000071',
      },
      key: {
        type: 'String',
        name: '員工編號',
        ragicId: '1000018',
        disabled: true,
      },
      storeRef: {
        type: 'ObjectId',
        refKeys: ['name'],
        input: 'select',
        reference: 'stores',
        name: '所屬門市',
        ragicId: '1000001',
      },
      staffName: {
        type: 'String',
        name: '姓名',
        ragicId: '1000020',
      },
      position: {
        name: '職務角色',
        type: 'Array',
        input: 'select',
        // multi: true,
        ragicId: '1000022',
        contents: [{
          options: ['店長', '驗光師', '副店長', '店員', '實習生'],
          type: 'String',
          name: 'options-element',
        }],
      },
      optometristLicenseSpExam: {
        name: '特考驗光師',
        type: 'String',
        options: ['應考未考上', '資格不符', '應考通過'],
        input: 'select',
        ragicId: '1000931',
      },
      optometryLicenseSpExam: {
        name: '特考驗光生',
        type: 'String',
        options: ['應考未考上', '資格不符', '應考通過'],
        input: 'select',
        ragicId: '1000932',
      },
      optometristLicenseHExam: {
        name: '高考驗光師',
        type: 'String',
        options: ['應考未考上', '資格不符', '應考通過'],
        input: 'select',
        ragicId: '1000933',
      },
      optometryLicenseNExam: {
        name: '普考驗光生',
        type: 'String',
        options: ['應考未考上', '資格不符', '應考通過'],
        input: 'select',
        ragicId: '1000934',
      },
      arrivalDate: {
        type: 'Date',
        name: '到職日',
        ragicId: '1000021',
      },
      status: {
        type: 'String',
        name: '工作狀態',
        options: ['在職', '離職'],
        input: 'select',
        default: '在職',
        ragicId: '1000033',
      },
      leaveDate: {
        type: 'Date',
        name: '離職日',
        ragicId: '1000034',
      },
      telephone: {
        type: 'String',
        name: '電話(家)',
        ragicId: '1000024',
      },
      gender: {
        name: '性別',
        type: 'String',
        options: ['男', '女'],
        input: 'select',
        ragicId: '1000035',
      },
      mobile: {
        type: 'String',
        name: '手機',
        ragicId: '1000042',
      },
      birthday: {
        type: 'Date',
        name: '生日',
        ragicId: '1000023',
      },
      email: {
        type: 'String',
        name: 'E-mail',
        ragicId: '1000028',
      },
      liveCity: {
        type: 'String',
        name: '居住縣市',
        ragicId: '1000026',
      },
      liveAddress: {
        type: 'String',
        name: '居住地址',
        ragicId: '1000027',
      },
      contact: {
        type: 'String',
        name: '緊急連絡人',
        ragicId: '1000029',
      },
      contactRelative: {
        type: 'String',
        name: '緊急聯絡人關係',
        ragicId: '1000030',
      },
      contactMobile: {
        type: 'String',
        name: '緊急聯絡人手機',
        ragicId: '1000032',
      },
      contactPhone: {
        type: 'String',
        name: '緊急聯絡人電話',
        ragicId: '1000031',
      },
      maritalStatus: {
        type: 'String',
        name: '婚姻狀態',
        options: ['未婚', '已婚'],
        input: 'select',
        ragicId: '1000039',
      },
      miliraryStatus: {
        type: 'String',
        name: '服役狀態',
        options: ['未役', '役畢'],
        input: 'select',
        ragicId: '1000040',
      },
      note: {
        type: 'String',
        name: '備註',
        ragicId: '1000041',
      },
      ragicStoreNodeId: {
        type: 'Number',
        name: 'Ragic門市資料Id',
        noclone: true,
      },
      ragicCenterNodeId: {
        type: 'Number',
        name: 'Ragic管理中心資料Id',
        noclone: true,
      },
      syncCenterAt: {
        type: 'Date',
        name: '上次同步管理中心時間',
      },
      syncStoreAt: {
        type: 'Date',
        name: '上次同步門市時間',
      },
      // bankCode: {
      //   type: 'String',
      //   name: '銀行編號',
      //   ragicId: '1000365',
      // },
      // bankName: {
      //   type: 'String',
      //   name: '銀行名稱',
      //   ragicId: '1000366',
      // },
      // bankAccount: {
      //   type: 'String',
      //   name: '銀行帳號',
      //   ragicId: '1000367',
      // },
      // bankAccountName: {
      //   type: 'String',
      //   name: '帳戶名稱',
      //   ragicId: '1000368',
      // },
      // dataForTransfer: {
      //   type: 'String',
      //   name: '匯款用資料',
      //   ragicId: '1000370',
      // },
    },
  },
  ui: {
    list: {
      columns: [
        { key: 'code', width: 100 },
        { key: 'key', width: 130 },
        { key: 'storeRef', width: 100 },
        { key: 'position', width: 100 },
        { key: 'status', width: 100 },
        { key: 'gender', width: 100 },
        { key: 'mobile', width: 100 },
        { key: 'note', width: 150 },
        { key: 'ragicCenterNodeId', width: 100 },
        { key: 'ragicStoreNodeId', width: 100 },
      ],
    },
    editor: {
      config: { titleSm: 2, titleMd: 1 },
      groups: [
        {
          name: '員工資料',
          rows: [
            [{ key: 'code' }],
            [{ key: 'key' }],
            [{ key: 'staffName' }],
            [{ key: 'storeRef' }],
            [{ key: 'position' }],
            [{ key: 'optometristLicenseSpExam' }],
            [{ key: 'optometryLicenseSpExam' }],
            [{ key: 'optometristLicenseHExam' }],
            [{ key: 'optometryLicenseNExam' }],
            [{ key: 'arrivalDate' }],
            [{ key: 'status' }],
            [{ key: 'leaveDate' }],
            [{ key: 'telephone' }],
            [{ key: 'gender' }],
            [{ key: 'mobile' }],
            [{ key: 'birthday' }],
            [{ key: 'email' }],
            [{ key: 'liveCity' }],
            [{ key: 'liveAddress' }],
            [{ key: 'contact' }],
            [{ key: 'contactRelative' }],
            [{ key: 'contactMobile' }],
            [{ key: 'contactPhone' }],
            [{ key: 'maritalStatus' }],
            [{ key: 'miliraryStatus' }],
            [{ key: 'note' }],
            // [{ key: 'bankCode' }],
            // [{ key: 'bankName' }],
            // [{ key: 'bankAccount' }],
            // [{ key: 'bankAccountName' }],
            // [{ key: 'dataForTransfer' }],
          ],
        },
      ],
    },
  },
}




// WEBPACK FOOTER //
// ./src/models/staffers.js